import React from 'react';
import PropTypes from 'prop-types';
import { MDBDropdown } from 'mdbreact';
import { t } from 'i18next';
import CreatAshipmentIcon from '../../../assets/icons/CreateAShipmentOrange.svg';
import DuplicateIcon from '../../../assets/icons/DuplicateOrange.svg';
import Row from '../../ReactComponent/Row';
import Column from '../../ReactComponent/Column';
import DownloadOrangeSmall from '../../../assets/icons/DownloadOrangeSmall.svg';
import PrimaryButton from '../../../lib/ui/buttons/PrimaryButton';
import SecondaryButton from '../../../lib/ui/buttons/SecondaryButton';
import { MDBDropdownToggle, StyledMDBDropdownMenu } from '../../_styledComponents/MDBDropdownToggle';
import { ReactComponent as DownloadSmallGrey } from '../../../assets/icons/DownloadSmallGrey.svg';
import { ReactComponent as DuplicateShipmentGrey } from '../../../assets/icons/DuplicateShipmentGrey.svg';
import { ReactComponent as CreateAShipmentGrey } from '../../../assets/icons/CreateAShipmentGrey.svg';
import { SummaryForm } from './Step4';
import {
  CategoryTitle,
  Step5ButtonsRow,
  Step5Label,
  IconWrapper,
  DropdownItem,
  StyledMDBDropdown,
  DropdownText,
  LastActionsContainer,
} from '../css';
import RatesSummary from './ContentBox/RatesSummary';

const NavActions = ({
  showBack, actions, quoteData, quoteApproved, isAuthenticated, printDisabled,
}) => {
  const isUnderReview = (quoteData && quoteData.underReview);

  const {
    gotoPreviousStep, printQuote, duplicateQuote, shipNow,
  } = actions;

  const gotoDashboard = () => {
    if (isAuthenticated) {
      window.location = '/view-user-dashboard';
    } else {
      window.location = '/';
    }
  };

  return (
    <Step5ButtonsRow justifyContent={(showBack) ? 'space-between' : 'flex-end'} showBack>
      <LastActionsContainer>
        {showBack
          && (
            <SecondaryButton
              label={t('Back')}
              onClick={(e) => {
                e.preventDefault();
                gotoPreviousStep();
              }}
              iconSrc={DownloadOrangeSmall}
              isIconLeftPosition
              showArrow
            />
          )}
        <SecondaryButton
          className="hideMobile"
          label={t('Print')}
          onClick={(e) => {
            e.preventDefault();
            printQuote();
          }}
          showArrow={false}
          iconSrc={DownloadOrangeSmall}
          disabled={printDisabled}
        />
        <SecondaryButton
          className="hideMobile"
          label={t('Duplicate')}
          onClick={(e) => {
            e.preventDefault();
            duplicateQuote();
          }}
          showArrow={false}
          iconSrc={DuplicateIcon}
          disabled={isUnderReview}
        />

        <SecondaryButton
          className="hideMobile"
          label={t('ShipNow')}
          onClick={(e) => {
            e.preventDefault();
            shipNow();
          }}
          showArrow={false}
          iconSrc={CreatAshipmentIcon}
          disabled={!quoteApproved}
        />

        <StyledMDBDropdown className="dropdown">
          <MDBDropdown>
            <MDBDropdownToggle>
              <Row>
                <Column $tablet={12}>
                  {t('Options')}
                </Column>
                <span className="icon icon-more-options" />
              </Row>
            </MDBDropdownToggle>

            <StyledMDBDropdownMenu className="text-white bg-dark" basic>
              <DropdownItem
                disabled={printDisabled}
                onClick={(e) => {
                  e.preventDefault();
                  if (!printDisabled) {
                    printQuote();
                  }
                }}
              >
                <IconWrapper>
                  <DownloadSmallGrey />
                </IconWrapper>
                <DropdownText>{t('Print')}</DropdownText>
              </DropdownItem>
              <DropdownItem onClick={(e) => {
                e.preventDefault();
                duplicateQuote();
              }}
              >
                <IconWrapper>
                  <DuplicateShipmentGrey />
                </IconWrapper>
                <DropdownText>{t('Duplicate')}</DropdownText>
              </DropdownItem>
              <DropdownItem
                disabled={!quoteApproved}
                onClick={(e) => {
                  e.preventDefault();
                  if (quoteApproved) {
                    shipNow();
                  }
                }}
              >
                <IconWrapper>
                  <CreateAShipmentGrey />
                </IconWrapper>
                <DropdownText>{t('ShipNow')}</DropdownText>
              </DropdownItem>
            </StyledMDBDropdownMenu>
          </MDBDropdown>
        </StyledMDBDropdown>

        <PrimaryButton
          label={t('Exit')}
          onClick={(e) => {
            e.preventDefault();
            gotoDashboard();
          }}
          showArrow
        />

      </LastActionsContainer>
    </Step5ButtonsRow>
  );
};

const Step5 = ({
  formData = {},
  serviceLevelQuotes,
  quoteApproved,
  chosenServiceLevelCode,
  quoteData,
  parentFields,
  billingAccounts,
  formHasBeenSubmited,
  currentStep,
  actions,
  isBasedOnAnExistingQuoteOrOrder,
  isAuthenticated,
  createQuoteData,
}) => {
  if (!quoteData) {
    return null;
  }

  if (!formHasBeenSubmited && currentStep !== 4) {
    return null;
  }

  let service = null;
  if (isBasedOnAnExistingQuoteOrOrder && serviceLevelQuotes.length === 0) {
    service = {
      accountType: null,
      totalCharges: quoteData.totalCharges,
      charges: quoteData.charges,
      description: quoteData.serviceLevelDescription,
      expectedDeliveryDate: quoteData.estimatedDeliveryDate,
      serviceLevelCode: quoteData.serviceLevelCode,
      tax: quoteData.tax,
      totalAmount: quoteData.totalAmount,
      isApproved: quoteData.isApproved,
    };
  } else {
    // eslint-disable-next-line prefer-destructuring
    service = serviceLevelQuotes && serviceLevelQuotes.filter((service) => service.serviceLevelCode === chosenServiceLevelCode)[0];
  }

  let description = '';
  if (service) {
    description = service.description;
  }

  const serviceAmount = service && service.totalAmount && service.totalAmount.value ? service.totalAmount.value : 0;
  const printDisabled = serviceAmount === 0 || (service && service.isApproved === false);

  const { totalAmount, quoteNumber } = quoteData;
  const { accessorials } = formData;
  const dataSource = parentFields.data.datasource;

  let protectedAccount = billingAccounts && billingAccounts.some((a) => a.accountNumber === formData.billTo && a.protected);

  if (formData && formData.division === 'Sameday' && formData.paymentMethod) {
    if (formData.paymentMethod === 'Collect'
      || ((formData.paymentMethod === 'Third Party' && protectedAccount) || formData.billToMethod === 'EnterBillTo')) {
      protectedAccount = true;
    }
  }

  return (
    <>
      <Row className="my-4">
        <Column $mobile={12} $tablet={6}>
          <CategoryTitle noMargins>{dataSource.step5CategoryTitle1 && dataSource.step5CategoryTitle1.value}</CategoryTitle>
          <Step5Label>
            {t('Quote')}
            :
            {' '}
            <span>{quoteNumber || t('PendingReview')}</span>
          </Step5Label>
        </Column>
        <Column $mobile={12} $tablet={6}>
          <NavActions
            quoteData={quoteData}
            actions={actions}
            isAuthenticated={isAuthenticated}
            quoteApproved={quoteApproved}
            printDisabled={printDisabled}
          />
        </Column>
      </Row>

      <CategoryTitle>{dataSource.step5CategoryTitle2 && dataSource.step5CategoryTitle2.value}</CategoryTitle>
      <RatesSummary
        formData={formData}
        quotesList={serviceLevelQuotes}
        selectedQuote={service}
        totalAmount={totalAmount}
        description={description}
        billingAccounts={billingAccounts}
        quoteApproved={quoteApproved}
        createQuoteData={createQuoteData}
      />

      <SummaryForm step={4} formData={formData} accessorialsList={accessorials} hideCube parentFields={parentFields} />

      <Row className="my-4">
        <Column $mobile={12}>
          <NavActions quoteData={quoteData} actions={actions} isAuthenticated={isAuthenticated} printDisabled={printDisabled} />
        </Column>
      </Row>

    </>
  );
};

NavActions.propTypes = {
  showBack: PropTypes.bool,
  actions: PropTypes.shape({
    gotoPreviousStep: PropTypes.func,
    printQuote: PropTypes.func,
    duplicateQuote: PropTypes.func,
    shipNow: PropTypes.func,
  }),
  quoteData: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  quoteApproved: PropTypes.bool,
  printDisabled: PropTypes.bool,

};

Step5.propTypes = {
  formData: PropTypes.object,
  serviceLevelQuotes: PropTypes.array,
  chosenServiceLevelCode: PropTypes.string,
  quoteData: PropTypes.object,
  parentFields: PropTypes.object,
  billingAccounts: PropTypes.array,
  formHasBeenSubmited: PropTypes.bool,
  currentStep: PropTypes.number,
  actions: PropTypes.shape({
    gotoPreviousStep: PropTypes.func,
    printQuote: PropTypes.func,
    duplicateQuote: PropTypes.func,
    shipNow: PropTypes.func,
  }),
  isBasedOnAnExistingQuoteOrOrder: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  quoteApproved: PropTypes.bool,
  createQuoteData: PropTypes.object,
};

export default Step5;
